module.exports = __webpack_public_path__ + "static/img/u15566.png";